import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAdminAuth } from "../section-components/AdminAuthContext";

const LoginAdmin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAdminAuth();

 const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    const response = await fetch("https://keurgui-backend-kjour.ondigitalocean.app/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, role: "admin" }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      setError(errorData.message || "Connexion échouée.");
      return;
    }

    const data = await response.json();

    if (!data.agent) {
      throw new Error("Réponse invalide du serveur");
    }

    login(data.agent);
    navigate("/admin");
  } catch (error) {
    setError("Une erreur est survenue.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-tabbs">
          <Link to="/login" className="tabb active">Connexion</Link>
        </div>

        <div className="login-content">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email*"
                required
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mot de passe*"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="theme-btn-1 btn btn-block"
            >
              {loading ? <div className="spinner"></div> : "Connexion"}
            </button>

            {error && <p className="error-message">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginAdmin;
